module.exports = __webpack_public_path__ + "media/images/hero-allcare-banner-1280-981c592cda2d27f512a6b8eafbacdcd0.webp";